export default `
	primaryImage {
		url
		kind
		extension
	}
`;
